<div class="row">
  <point-edit-notes
    [processing]="processing"
    [point]="point"
    (toggleSavePoint)="savePoint($event)"
    (toggleCancel)="cancel()"
  ></point-edit-notes>
</div>
